import React, { useState } from 'react'
import Select, { MenuPlacement } from 'react-select'
import { FoundationsGeneric } from './FoundationsGeneric'
import { FoundationsSelectType } from '../Types/FoundationsTypes'
import InformativeTooltip from './Tooltip/InfoTooltip'

const FoundationsSelect: React.FC<FoundationsSelectType> = ({
    options = [],
    isSearchable = false,
    isMultiSelect = false,
    title,
    menuPlacement= "auto",
    ...props
}) => {
    const formattedOptions = Array.isArray(props.value) && props.value.length >= 2 ? [] : options.filter(
        (option) => option.value !== undefined && option.value !== null
    )
    const handleChange = (selectedOption: any) => {
        //FP-11666 - Below code is un-necessory as per behaviour of react-select input and output type
        // if (isSearchable || isMultiSelect) {
        //     const formattedValue = isMultiSelect
        //         ? (selectedOption || []).reduce( //reduce will return single element, but react-select's default return type for multiselect is array of object(s)
        //             (acc: any, option: any) => ({ ...acc, [props.id]: option.value }),
        //             {}
        //         )
        //         : {
        //             [props.id]: selectedOption
        //                 ? selectedOption.value === props.placeHolder
        //                     ? ''
        //                     : selectedOption.value
        //                 : '',
        //         }
        //     // props.onChange !== undefined ? props.onChange(formattedValue) : () => { }
        // } else {
        //     props.onChange !== undefined ? props.onChange(selectedOption) : () => { }
        // }
        props.onChange !== undefined ? props.onChange(selectedOption) : () => { }
    }

    const noOptionsMessage = () => {
    return props?.value && props?.value.length >= 2
      ? 'You can only select 2 items'
      : 'No more options available';
  };
    
    return (
        <FoundationsGeneric
            id={props.id + '_container'}
            customStyle={props.customStyle}
            classes={props.classes}
        >
            {props.labelText !== undefined && (
                <label className={(props.labelClasses || '') + ' col-form-label'} title={String(title)}>
                    {props.labelText}
                    {props.optional && <small className="text-muted">(optional)</small>}
                    {props.isAsterisk && <span style={{ color: 'red' }}>&#42;</span>}
                </label>
            )}

            <span className={props.containerClasses || ''}>
                {isSearchable || isMultiSelect ? (
                    <Select
                        noOptionsMessage={noOptionsMessage}
                        id={props.id}
                        menuPlacement={menuPlacement as MenuPlacement || "auto"}
                        menuPortalTarget={document.body}
                        className={(props.selectClasses || '') + 'ReactSelect'}
                        options={formattedOptions}
                        isMulti={isMultiSelect}
                        isClearable={props.isClearable ?? false}
                        value={props.value}
                        onChange={handleChange}
                        placeholder={props.placeHolder}
                        styles={{...props.selectCustomStyles, menuPortal: base => ({ ...base, zIndex: 9999 })}}
                        isOptionDisabled={(option) => (Array.isArray(props.value) && props.value.length >= 2) ? true: option.disabled}
                        //FP-10620
                        formatOptionLabel={(option) => (
                            <div>
                                <div
                                   title={(option.title || option.label) as string}
                                   style={{ position: 'relative', cursor: 'pointer' }}
                                >
                                    {option.label}
                                </div>
                            </div>
                        )}
                    />
                ) : (
                    // Standard Select dropdown without search functionality
                    <select
                        name={props.name}
                        id={props.id}
                        className={(props.selectClasses || '') + ' '}
                        disabled={props.disabled ? props.disabled : false}
                        multiple={isMultiSelect}
                        style={
                            props.customStyles
                                ? props.customStyles
                                : { height: 'auto' }}
                        value={props.value}
                        data-hash={props.hash}
                        data-collection_index={props.collectionIndex}
                        data-is_text_value={props.isTextValue}
                        onInput={handleChange}
                        {...(props.registerFunction
                            ? props.registerFunction(props.registerName, props.registerRules)
                            : {})}
                    >
                        {props.placeHolder && (
                            <option value="" disabled>
                                {props.placeHolder}
                            </option>
                        )}
                        {props.children}
                         {/* FP-10620 */}
                        {formattedOptions.map((option) => (
                            <option
                                key={option.value}
                                value={option.value}
                                title={String(option.title)} 
                            >
                                {option.label}
                            </option>
                        ))}
                    </select>
                )}

                {props.error && (
                    <div style={{ height: '17px' }}>
                        <label htmlFor={props.id} className="error field-validation-error d-block">
                            {'' + props.error}
                        </label>
                    </div>
                )}
            </span>

            {props.toolTipText && (
                <div className={'text-right info-icon d-inline-block ' + props.tooltipClasses}>
                    <InformativeTooltip
                        content={props.toolTipText}
                        placement="right-end"
                        animation="shift-away-subtle"
                        allowHTML={true}
                        showIcon={true}
                        theme = "default-tooltip"
                    />
                </div>
                // FP-10632 Updated the earlier tooltip implementation with the new one (InformativeTooltip)
            )}
        </FoundationsGeneric>
    )
}

export default FoundationsSelect
